import {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText,
    View
} from '../../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {
    BorderlessButton,
    ThemeButton
} from '../../../../custom-packages/react-button-package/ButtonPackage';

import TMenuEditorScreen from './Translations/TMenuEditorScreen';

import AppConfig from '../../../../AppConfig';

import {useParams} from "react-router-dom";
import MenuLogo from "../../../../components/admin/Menu/MenuLogo";
import Styles from "../../../../Styles";

import {GetAuthObject} from '../../../../authentication/AuthFunctions';
import ChocoControl from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";
import Menu from "../../../../models/menu/Menu";
import ChocoFormTS from '../../../../custom-packages/react-chocoforms/typescript/ChocoFormTS';
import ChocoForm from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import MenuEditorTopBar from "./Components/MenuEditorTopBar";
import MenuEditorBottomBar from "./Components/MenuEditorBottomBar";

const MenuHeaderScreen = (props) => {
    const auth = GetAuthObject();

    const params = useParams()
    const id = params.id;

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [menu, setMenu] = useState<Menu | null>(null);
    const [mainForm, setMainForm] = useState(new ChocoForm({
        men_name: new ChocoControl({
            elementType: 'input',
            elementConfig: {
                placeholder: TMenuEditorScreen[AppConfig.lang].MENU_NAME,
                autoCapitalize: 'words'
            },
            label: TMenuEditorScreen[AppConfig.lang].MENU_NAME,
            value: '',
            style: {
                textAlign: 'center',
            },
            labelStyle: {
                textAlign: 'center',
                left: 0,
                right: 0
            },
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
    }));

    const editHeader = async () => {
        const controls = {...mainForm.controls};

        if (mainForm.edited && mainForm.isValidForm) {
            setSaving(true)

            let formData = {};

            formData['men_id'] = id;

            for (let key in controls) {
                formData[key] = controls[key].value;
            }

            const response = await fetch(AppConfig.URL + '/Menu/Create/' + id, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                setMainForm(new ChocoForm(controls))
            }

            setSaving(false)
        } else {

        }
    }

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchMenu/" + id, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            var json = await response.json();

            const mainControls = {...mainForm.controls}

            mainControls['men_name'].value = json.menu.men_name;

            setMenu(json.menu);
            setMainForm(new ChocoForm(mainControls));

            setLoading(false);
        };

        f();
    }, [id]);

    if (loading)
        return <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
            <MenuEditorTopBar
                menuID={id}
            />
            <MenuEditorBottomBar
                menuID={id}
            />
            <View style={{height: 70}}></View>
            <ActivityIndicator style={{marginTop: 170}}/>
        </View>

    if(!menu)
        return <View></View>

    return <View>
        <MenuEditorTopBar
            menuID={id}
        />
        <MenuEditorBottomBar
            menuID={id}
        />
        <View style={{height: 70}}></View>
        <View className={'row'}>
            <View className={'col-lg-4'}>
                <View>
                    <CCText>
                        <h1
                            style={{marginBottom: 0}}
                        >
                            {TMenuEditorScreen[AppConfig.lang].HEADER}
                        </h1>
                    </CCText>
                    <CCText
                        style={{
                            color: '#666666',
                            fontStyle: 'italic',
                            fontSize: '1.15rem'
                        }}
                    >
                        {TMenuEditorScreen[AppConfig.lang].HEADER_DESC}
                    </CCText>
                </View>
                <View
                    className={'card'}
                    style={{marginTop: 15}}
                >
                    <View
                        className={'card-body'}
                        style={{padding: 0}}
                    >
                        <View
                            style={{justifyContent: 'center', alignItems: 'center', padding: 15, paddingTop: 0}}
                        >
                            <View style={{marginTop: 30, marginBottom: 30,}}>
                                <MenuLogo
                                    imageStyle={{width: 100, height: 100}}
                                    menuID={menu.men_id}
                                    imageLq={menu.men_logo}
                                    onImageChanged={(image) => {
                                        const updatedMenu = {...menu}

                                        updatedMenu.men_logo = image

                                        setMenu(updatedMenu)
                                    }}
                                />
                                {
                                    menu.men_logo ?
                                        <BorderlessButton
                                            text={TMenuEditorScreen[AppConfig.lang].REMOVE}
                                            textStyle={{...Styles.redColor}}
                                            onPress={async () => {
                                                const response = await fetch(AppConfig.URL + "/Menu/RemoveLogo/" + menu.men_id, {
                                                    method: 'GET',
                                                    headers: {
                                                        'Accept': 'application/json',
                                                        'Content-Type': 'application/json',
                                                        'Authorization': auth.token
                                                    }
                                                });

                                                const r = await response.json();

                                                if (r.success) {
                                                    const updatedMenu = {...menu}

                                                    updatedMenu.men_logo = null

                                                    setMenu(updatedMenu)
                                                }
                                            }}
                                        />
                                        :
                                        null
                                }
                            </View>
                            <ChocoFormTS
                                lang={AppConfig.lang}
                                form={mainForm}
                                onFormChange={(updatedForm) => {
                                    setMainForm(updatedForm)
                                }}
                            />
                            <View style={{
                                marginTop: 15,
                                width: '100%',
                                flexDirection: 'row',
                                justifyContent: 'flex-end'
                            }}>
                                <ThemeButton
                                    disabled={!mainForm.isValidForm || saving}
                                    text={saving ?
                                        <ActivityIndicator size={20} color={'white'}/>
                                        :
                                        TMenuEditorScreen[AppConfig.lang].SAVE}
                                    onPress={editHeader}
                                />
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </View>
        <View style={{height: 100}}></View>
    </View>;
}

export default MenuHeaderScreen;